import { render, staticRenderFns } from "./SQNoResults.vue?vue&type=template&id=5b8299c4&"
import script from "./SQNoResults.vue?vue&type=script&lang=ts&"
export * from "./SQNoResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports